export type XTMQueryProps = 'xtmProjectName' | 'fileName';
export type MKTQueryProps = 'fileName';

export const XTM_FILENAME_PROP: XTMQueryProps = 'fileName';
export const XTM_PROJECTNAME_PROP: XTMQueryProps = 'xtmProjectName';

export const MKT_FILENAME_PROP: MKTQueryProps = 'fileName';

export const INTERNAL_SUPPLIER = 'SAP (..)';
export const TRAINING_PROJECT_NAME = 'Training Project';

export const QT_IMPORT_AZURE_ROLE_VALUE = 'QTImport';

export const IDLE_TIMEOUT = 3_300_000; // 55 minutes in milliseconds
